export default __webpack_public_path__ + "static/IN-8015_2-8mm_lense_night_hardwareWDR-4ff63d9e737da2c27fa60111ef3df063.webp";